/* eslint-disable */
class GenericFilterManager {
    constructor(config) {
        this.config = {
            containerId: 'filtersBar',
            filters: [],
            onFilterChange: () => {},
            ...config
        };
        
        this.activeFilters = {};
        this.currentOpenDropdown = null;
        this.dropdownTemplate = null;
        
        this.init();
    }
    
    init() {
        this.renderFilters();
        this.setupEventListeners();
    }
    
    renderFilters() {
        const $container = $('#' + this.config.containerId);
        if (!$container.length) return;
        
        $container.find('.generic-filter-pill').remove();
        
        this.config.filters.forEach((filter) => {
            const $pill = this.createFilterPill(filter);
            $container.append($pill);
        });
    }
    
    getIconForFilter(key) {
        const icons = {
            status: 'fa-circle',
            criticality: 'fa-exclamation-triangle',
            downtime: 'fa-clock',
            asset: 'fa-microchip',
            type: 'fa-tag',
            model: 'fa-cube',
            priority: 'fa-flag',
            location: 'fa-location-dot',
            department: 'fa-building',
            id: 'fa-hashtag',
            name: 'fa-user',
            role: 'fa-user-tag',
            default: 'fa-filter',
            asset_type: 'fa-cubes',
            vendor: 'fa-industry',
             category: 'fa-th-large',
             assigned_to: 'fa-user',
        };
        return icons[key] || icons.default;
    }
    
    createFilterPill(filter) {
        const iconClass = this.getIconForFilter(filter.key);
        const $btn = $(`<button class="generic-filter-pill" data-filter-key="${filter.key}" data-filter-type="${filter.type || 'checkbox'}"><i class="fas ${iconClass} text-primary me-1"></i> ${filter.label} <i class="fas fa-chevron-down ms-1"></i></button>`);
        
        if (this.activeFilters[filter.key] && this.activeFilters[filter.key] !== '') {
            $btn.addClass('active');
            const value = this.activeFilters[filter.key];
            if (typeof value === 'string' && value.length > 0) {
                $btn.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${filter.label}: ${value} <i class="fas fa-chevron-down ms-1"></i>`);
            } else if (Array.isArray(value) && value.length === 1) {
                const selectedOption = filter.options?.find(opt => opt.value === value[0]);
                if (selectedOption) {
                    $btn.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${selectedOption.label} <i class="fas fa-chevron-down ms-1"></i>`);
                }
            } else if (Array.isArray(value) && value.length > 1) {
                $btn.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${filter.label} (${value.length}) <i class="fas fa-chevron-down ms-1"></i>`);
            }
        }
        
        $btn.on('click', (e) => {
            e.stopPropagation();
            this.showFilterDropdown(filter, $btn);
        });
        
        return $btn;
    }
    
    showFilterDropdown(filter, $anchorButton) {
        this.closeDropdown();
        
        if (!this.dropdownTemplate) {
            const $templateElem = $('#genericFilterDropdownTemplate');
            if ($templateElem.length) {
                this.dropdownTemplate = $templateElem.clone().css('display', 'block').removeAttr('id');
                $('body').append(this.dropdownTemplate);
            }
        }
        
        if (!this.dropdownTemplate) return;
        
        const $clone = this.dropdownTemplate.clone();
        const $dropdown = $clone.find('.generic-filter-dropdown');
        $dropdown.attr('id', `dropdown-${filter.key}`);
        
        this.setupDropdownContent($clone, filter);
        
        const offset = $anchorButton.offset();
        $dropdown.css({
            position: 'absolute',
            top: offset.top + $anchorButton.outerHeight() + 5,
            left: offset.left,
            zIndex: 1050
        });
        
        $('body').append($clone);
        this.currentOpenDropdown = $clone;
        $dropdown.addClass('show');
        
        setTimeout(() => {
            const closeHandler = (e) => {
                if (!$clone.is(e.target) && !$clone.has(e.target).length && !$anchorButton.is(e.target) && !$anchorButton.has(e.target).length) {
                    $clone.remove();
                    $(document).off('click', closeHandler);
                    if (this.currentOpenDropdown?.is($clone)) this.currentOpenDropdown = null;
                }
            };
            $(document).on('click', closeHandler);
        }, 100);
    }
    
    setupDropdownContent($dropdownElem, filter) {
        const $optionsContainer = $dropdownElem.find('.filter-options-container');
        const $searchInput = $dropdownElem.find('.filter-search-input');
        const $clearBtn = $dropdownElem.find('.filter-clear-btn');
        const $applyBtn = $dropdownElem.find('.filter-apply-btn');
        
        const type = filter.type || 'checkbox';
        const currentValue = this.activeFilters[filter.key];
        
        // For input type
        if (type === 'input') {
            const placeholder = filter.placeholder || `Filter by ${filter.label}`;
            $optionsContainer.html(`
                <div class="filter-option-input">
                    <input type="text" class="filter-text-input" placeholder="${placeholder}" value="${currentValue || ''}">
                </div>
            `);
            
            const $textInput = $optionsContainer.find('.filter-text-input');
            
            // Hide search input for input type
            $searchInput.closest('.dropdown-header').hide();
            
            $applyBtn.off('click').on('click', () => {
                const value = $textInput.val().trim();
                if (value) {
                    this.activeFilters[filter.key] = value;
                } else {
                    delete this.activeFilters[filter.key];
                }
                this.updateFilterPillUI(filter);
                this.config.onFilterChange(this.getActiveFilters());
                $dropdownElem.remove();
                this.currentOpenDropdown = null;
            });
            
            $clearBtn.off('click').on('click', () => {
                $textInput.val('');
            });
            
            // Enter key press
            $textInput.off('keypress').on('keypress', (e) => {
                if (e.which === 13) {
                    $applyBtn.click();
                }
            });
            
            return;
        }
        
        // For checkbox/radio types
        const currentValues = Array.isArray(currentValue) ? currentValue : [];
        const options = filter.options || [];
        
        const renderOptions = (searchTerm = '') => {
            const filtered = options.filter(opt => 
                opt.label.toLowerCase().includes(searchTerm.toLowerCase())
            );
            
            let html = '';
            filtered.forEach(opt => {
                const isChecked = currentValues.includes(opt.value);
                if (type === 'radio') {
                    html += `
                        <div class="filter-option">
                            <input type="radio" name="filter-${filter.key}" value="${opt.value}" id="${filter.key}_${opt.value}" ${isChecked ? 'checked' : ''}>
                            <label for="${filter.key}_${opt.value}">${opt.label}</label>
                        </div>
                    `;
                } else {
                    html += `
                        <div class="filter-option">
                            <input type="checkbox" value="${opt.value}" id="${filter.key}_${opt.value}" ${isChecked ? 'checked' : ''}>
                            <label for="${filter.key}_${opt.value}">${opt.label}</label>
                        </div>
                    `;
                }
            });
            $optionsContainer.html(html);
        };
        
        renderOptions();
        
        // Show search input for checkbox/radio
        $searchInput.closest('.dropdown-header').show();
        $searchInput.off('input').on('input', (e) => renderOptions(e.target.value));
        
        $clearBtn.off('click').on('click', () => $optionsContainer.find('input').prop('checked', false));
        $applyBtn.off('click').on('click', () => {
            const selected = [];
            $optionsContainer.find('input:checked').each(function() {
                selected.push($(this).val());
            });
            
            if (selected.length > 0) {
                this.activeFilters[filter.key] = selected;
            } else {
                delete this.activeFilters[filter.key];
            }
            
            this.updateFilterPillUI(filter);
            this.config.onFilterChange(this.getActiveFilters());
            $dropdownElem.remove();
            this.currentOpenDropdown = null;
        });
    }
    
    updateFilterPillUI(filter) {
        const $pill = $(`.generic-filter-pill[data-filter-key="${filter.key}"]`);
        if (!$pill.length) return;
        
        const iconClass = this.getIconForFilter(filter.key);
        const value = this.activeFilters[filter.key];
        
        if (value && (Array.isArray(value) ? value.length > 0 : value !== '')) {
            $pill.addClass('active');
            if (filter.type === 'input' && typeof value === 'string') {
                $pill.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${filter.label}: ${value} <i class="fas fa-chevron-down ms-1"></i>`);
            } else if (Array.isArray(value) && value.length === 1) {
                const selectedOption = filter.options?.find(opt => opt.value === value[0]);
                $pill.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${selectedOption?.label || value[0]} <i class="fas fa-chevron-down ms-1"></i>`);
            } else if (Array.isArray(value) && value.length > 1) {
                $pill.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${filter.label} (${value.length}) <i class="fas fa-chevron-down ms-1"></i>`);
            }
        } else {
            $pill.removeClass('active');
            $pill.html(`<i class="fas ${iconClass} text-primary me-1"></i> ${filter.label} <i class="fas fa-chevron-down ms-1"></i>`);
        }
    }
    
    closeDropdown() {
        if (this.currentOpenDropdown) {
            this.currentOpenDropdown.remove();
            this.currentOpenDropdown = null;
        }
    }
    
    getActiveFilters() {
        return { ...this.activeFilters };
    }
    
    clearAllFilters() {
        this.activeFilters = {};
        this.config.filters.forEach(filter => this.updateFilterPillUI(filter));
        this.config.onFilterChange(this.getActiveFilters());
    }
    
    setupEventListeners() {
        $(document).on('keydown', (e) => {
            if (e.key === 'Escape') this.closeDropdown();
        });
    }
    
    destroy() {
        this.closeDropdown();
        $('#' + this.config.containerId).empty();
    }
}

window.GenericFilterManager = GenericFilterManager;